import React from 'react';
import {TextInput, Create, SimpleForm, required, minLength,BooleanInput} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {HASH_TAG} from '../../consts/Names';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   }
}));

export const HashTagCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />}>
         <SimpleForm className={classes.formContainer} redirect="list">
            <TextInput className={classes.textFld} label="Tag Name" source={HASH_TAG.name} validate={[required(), minLength(3)]} parse={v => {
               return v.toLowerCase().trim().replace(/\W/g, '');}
               }/>
            <BooleanInput label="Snapshot Hashtags" source="is_snapshot" />
         </SimpleForm>
      </Create>
   );
};
